module.exports = __webpack_public_path__ + "assets/6ab3777cb7d65515a03c5b10c343505c.png";